import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../data/GlobalContext';
import { promoURL } from '../../../App';

const transactions = [
    // {
    // 	id: 1,
    // 	tickets: 5,
    // 	title: "Daily Mission Completed",
    // 	description: "Deposit and JILI turnover requirement completed",
    // 	date: "09 Sep 2026",
    // 	time: "03:45 PM",
    // },
    // {
    // 	id: 2,
    // 	tickets: 15,
    // 	title: "Tier 3 Reward",
    // 	description: "Reached daily turnover milestone",
    // 	date: "08 Sep 2026",
    // 	time: "10:21 PM",
    // },
    // {
    // 	id: 3,
    // 	tickets: 1,
    // 	title: "Deposit Reward",
    // 	description: "Minimum deposit requirement achieved",
    // 	date: "08 Sep 2026",
    // 	time: "08:05 AM",
    // },
    // {
    // 	id: 4,
    // 	tickets: 3,
    // 	title: "Daily Mission Completed",
    // 	description: "Daily mission requirement completed",
    // 	date: "07 Sep 2026",
    // 	time: "06:15 PM",
    // },
    // {
    // 	id: 5,
    // 	tickets: 10,
    // 	title: "Tier 2 Reward",
    // 	description: "Reached daily turnover milestone",
    // 	date: "07 Sep 2026",
    // 	time: "02:30 PM",
    // },
    // {
    // 	id: 6,
    // 	tickets: 2,
    // 	title: "Deposit Reward",
    // 	description: "Minimum deposit requirement achieved",
    // 	date: "06 Sep 2026",
    // 	time: "11:20 AM",
    // },
    // {
    // 	id: 7,
    // 	tickets: 5,
    // 	title: "Daily Mission Completed",
    // 	description: "Deposit and JILI turnover requirement completed",
    // 	date: "05 Sep 2026",
    // 	time: "09:45 PM",
    // },
];

const ITEMS_PER_PAGE = 3;

export default function TicketHistory({ onBack }) {
    const [currentPage, setCurrentPage] = useState(1);
    const { username } = useGlobalContext();

    const hasTransactions = transactions.length > 0;

    const totalPages = hasTransactions
        ? Math.ceil(transactions.length / ITEMS_PER_PAGE)
        : 0;

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;

    const currentTransactions = transactions.slice(startIndex, endIndex);

    useEffect(() => {
        if (totalPages === 0) {
            setCurrentPage(1);
            return;
        }

        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    const handlePrevious = () => {
        setCurrentPage((page) => Math.max(page - 1, 1));
    };

    const handleNext = () => {
        setCurrentPage((page) => Math.min(page + 1, totalPages));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const [rewardHistory, setRewardHistory] = useState([]);
    const [rewardHistoryLoading, setRewardHistoryLoading] = useState(false);

    useEffect(() => {
        if (!username) return;

        const getJiliFortuneRushRewardHistory = async () => {
            try {
                setRewardHistoryLoading(true);

                const formData = new URLSearchParams();
                formData.append('cmd', 'getJiliFortuneRushRewardHistory');
                formData.append('u', username);

                const response = await fetch(promoURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData.toString(),
                });

                const data = await response.json();

                console.log('JILI Fortune Rush Reward History:', data);

                if (data) {
                    setRewardHistory(data);
                }
            } catch (error) {
                console.error(
                    'Error getting JILI Fortune Rush Reward History:',
                    error
                );
            } finally {
                setRewardHistoryLoading(false);
            }
        };

        getJiliFortuneRushRewardHistory();
    }, [username]);

    return (
        <>
            <div className="ticket-history-header-title">
                <h2>Your Ticket Rewards</h2>

                <p>
                    Track your earned JILI Rush tickets and see which activities
                    helped you collect them.
                </p>
            </div>

            <motion.div
                className="ticket-history"
                initial={{
                    opacity: 0,
                    y: 20,
                }}
                animate={{
                    opacity: 1,
                    y: 0,
                }}
            >
                <div className="ticket-history-list">
                    {hasTransactions ? (
                        currentTransactions.map((item, index) => (
                            <motion.div
                                key={`${currentPage}-${item.id}`}
                                className="ticket-history-item"
                                initial={{
                                    opacity: 0,
                                    x: -20,
                                }}
                                animate={{
                                    opacity: 1,
                                    x: 0,
                                }}
                                transition={{
                                    delay: index * 0.08,
                                }}
                            >
                                <div className="ticket-history-icon">
                                    <img
                                        src="/images/game/jili-rush/JILI-TICKET.webp"
                                        alt="JILI Ticket"
                                    />
                                </div>

                                <div className="ticket-history-content">
                                    <div className="ticket-history-title">
                                        <h3>{item.title}</h3>

                                        <span>+{item.tickets}</span>
                                    </div>

                                    <p>{item.description}</p>

                                    <small>
                                        {item.date}
                                        {' • '}
                                        {item.time}
                                    </small>
                                </div>
                            </motion.div>
                        ))
                    ) : (
                        <motion.div
                            className="ticket-history-empty"
                            initial={{
                                opacity: 0,
                                y: 10,
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                            }}
                        >
                            <img
                                src="/images/game/jili-rush/JILI-TICKET.webp"
                                alt="No ticket history"
                            />

                            <h3>No Ticket History</h3>

                            <p>You haven't earned any JILI Rush tickets yet.</p>
                        </motion.div>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="ticket-history-pagination">
                        <button
                            type="button"
                            className="pagination-arrow"
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                            aria-label="Previous page"
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>

                        <div className="pagination-pages">
                            {Array.from(
                                { length: totalPages },
                                (_, index) => index + 1
                            ).map((page) => (
                                <button
                                    type="button"
                                    key={page}
                                    className={`pagination-page ${
                                        currentPage === page ? 'active' : ''
                                    }`}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            ))}
                        </div>

                        <button
                            type="button"
                            className="pagination-arrow"
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                            aria-label="Next page"
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                )}
            </motion.div>

            <div className="stats-panel-table">
                <button type="button" onClick={onBack}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Back
                </button>
            </div>
        </>
    );
}
